import { useAnalytics } from 'utils/hooks/useAnalytics'
import { FP_ANALYTICS_EVENTS } from './events'

export const useFMSAnalytics = () => {
  const { identifyUser, trackEvent } = useAnalytics({
    appEvents: FP_ANALYTICS_EVENTS,
    appName: 'FMS',
  })

  return {
    identifyUser,
    trackEvent,
  }
}
